



































import {Component, Emit, Prop, Vue, Watch} from 'vue-property-decorator';
import BButton from 'buefy/src/components/button/Button.vue';
import {Action, Getter, State, Mutation} from 'vuex-class';
import BInput from 'buefy/src/components/input/Input.vue'; // @ is an alias to /src
import BField from 'buefy/src/components/field/Field.vue'; // @ is an alias to /src
import BDropdown from 'buefy/src/components/dropdown/Dropdown.vue';
import BDropdownItem from 'buefy/src/components/dropdown/DropdownItem.vue';
import BSelect from 'buefy/src/components/select/Select.vue';


import {MAFUser} from '@/store/User/types';
import {LookupDistance, lookupIcon, LookupIcon} from '@/store/types'; // @ is an alias to /src
import BModal from 'buefy/src/components/modal/Modal.vue';
import UploadModal from './UploadModal.vue';
import AvatarCreator from './AvatarCreator.vue';

const namespace = 'userState';
@Component({
    components: {
        BDropdown,
        BDropdownItem,
        BSelect,
        BField,
        BButton,
        BInput,
        UploadModal,
        BModal,
        AvatarCreator,
    },
})
export default class AvatarPictureInfo extends Vue {
    @Prop(MAFUser) public readonly self!: MAFUser;
    @Action('updateSelfDoc', {namespace}) public updateSelfDoc: any;
    @Mutation('setSelf', {namespace: 'userState'}) public setSelf: any;

    public showUploadModal: boolean;
    public showAvatarCreator: boolean;
    public BASE_URL: string;
    public update: MAFUser;
    public isLoading: boolean;
    constructor() {
        super();
        this.showAvatarCreator = false;
        this.showUploadModal = false;
        this.isLoading = false;
        this.BASE_URL = process.env.BASE_URL ? process.env.BASE_URL : '';
        this.update = this.self;
    }
    public triggerModal() {
        this.showUploadModal = true;
    }
    public triggerAvatar() {
        this.showAvatarCreator = true;
    }
    public async submit(event: any) {
        event.preventDefault();
        this.isLoading = true;
        this.update.signUpPhase = 5;

        try {
            await this.updateSelfDoc(this.update.toPlainObj());
            this.setSelf(this.update);
        } catch (error) {
            this.$snackbar.open({
                message: 'Error saving user please try again.',
                type: 'is-danger',
                indefinite: true,
            });
        }

        this.isLoading = false;
    }
}
